import {useEffect} from "react";
export const CRITEO_SCRIPT_SRC = '//dynamic.criteo.com/js/ld/ld.js?a=99559'
window.criteo_q = window.criteo_q || [];
const CRITEO_ACCOUNT_ID = 99559

const deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";

export const CriteoTr = {

}

export const CRITEO_EVENTS = {
    VIEW_HOMEPAGE: 'viewHome',
    FORM_SUBMITTED: 'trackTransaction'
}

export const Criteo_trackEvent = (eventName, values = {}) => {
    console.log('criteo: ', window.criteo_q)
    window.criteo_q.push(
        { event: "setAccount", account: CRITEO_ACCOUNT_ID },
        { event: "setSiteType", type: deviceType},
        { event: eventName, ...values }
    );
}